import PropTypes from "prop-types"
import React, { useState, useEffect, useMemo } from "react"
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import "react-datepicker/dist/react-datepicker.css"
import { mobileRegex, iuRegex,vehicleRegex } from "../../helpers/validator"
// actions
import { addNewBlacklist, updateBlacklist, clearMessage } from "../../store/blacklists/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { isEmpty } from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"


const BlacklistCreate = props => {
  const dispatch = useDispatch()
  const { blacklist, setSelectedBlacklist, toggle, isOpen } = props
  // Form validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      vehicle: blacklist?.vehicle || "",
    },
    validationSchema: Yup.object({
      vehicle: Yup.string().matches(vehicleRegex,"Invalid Vehicle Number"      )
      .max(8, "Invalid Vehicle Number")
      .min(3, "Invalid Vehicle Number")
      .required("Please enter blacklist title"),
    }),
    onSubmit: values => {
      let blacklistObj = {
        vehicle: values["vehicle"].trim(),
        status: "Available",
      }
      
      if (!isEmpty(blacklist)) {
        blacklistObj = { ...blacklistObj, id: blacklist._id }
        dispatch(updateBlacklist(blacklistObj))
      } else {
        dispatch(addNewBlacklist(blacklistObj))
      }
      setSelectedBlacklist({})
    },
  })

  useEffect(() => {
    if (blacklist && !isEmpty(blacklist)) {
      validation.initialValues = {
        vehicle: blacklist?.vehicle || "",
      }
    }
  }, [blacklist])

  const { error, message } = useSelector(state => ({
    error: state.blacklists.error,
    message: state.blacklists.message,
  }))

  useMemo(() => {
    if (message) {
      toastr.success(message, "Blacklist Creation")
      toggle()
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, message])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(
        error?.message || error || "Oops..Something went wrong.",
        "Blacklist Creation"
      )
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])
  
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={"modal-lg"}>
      <ModalHeader toggle={toggle} tag="h4">
        {blacklist ? "Update Blacklist" : "Add New Blacklist"}
      </ModalHeader>
      <ModalBody>
        <React.Fragment>
          <Col lg="24" xl="24">
            <Form
              className="form-row"
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
    
              <FormGroup row>
                <Col md={8}>
                  <Label
                    htmlFor="blacklisttitle"
                    className="col-form-label col-md-8"
                  >
                    Vehicle*
                  </Label>
                  <Input
                    id="vehicle"
                    name="vehicle"
                    type="text"
                    className="form-control"
                    placeholder="Enter blacklist title..."
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.vehicle || ""}
                    invalid={
                      validation.touched.vehicle &&
                      validation.errors.vehicle
                        ? true
                        : false
                    }
                  />
                  {validation.touched.vehicle &&
                  validation.errors.vehicle ? (
                    <FormFeedback type="invalid">
                      {validation.errors.vehicle}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>

              <Row className="justify-content-end">
                <Col xl="12" className="text-end">
                  <Button type="submit" color="primary">
                    {isEmpty(blacklist) ? "Add New Blacklist" : "Update Blacklist"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </React.Fragment>
      </ModalBody>
    </Modal>
  )
}

export default BlacklistCreate
BlacklistCreate.propTypes = {
  history: PropTypes.object,
  blacklist: PropTypes.object,
  setSelectedBlacklist: PropTypes.func,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
}
